import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {login,logout,authQueryLogin} from 'actions';
import WithNotifications from 'containers/WithNotifications';
import LoginView from './view';

class Login extends PureComponent{
    constructor(props){
        super(props);

        this.state={
            email:"",
            password:"",
            redirect:""
        }

        this.onChange=this.onChange.bind(this);
        this.onLogin=this.onLogin.bind(this);
    }
    componentWillMount(){
        if(this.props.authenticated && !this.props.authoriseFlow){
            this.props.history.push('/apps');
        }
    }
    componentWillReceiveProps(nextProps){
        if(this.props.redirect){
            this.setState({redirect:this.props.redirect});
        }
        if(nextProps.authenticated){
            this.props.dismissNotification();
            if (this.state.redirect && this.state.redirect !== "") {
                this.props.history.push(this.state.redirect);
            }
            else {
                this.props.history.push('/apps');
            }
        }
        if(nextProps.error && !this.props.error){
            this.props.addNotification('error','There was a problem logging you in - please check your internet connection')
        }
        if(nextProps.authError && !this.props.authError){
            this.props.addNotification('error','There was a problem logging you in - please check your details')
        }
    }
    onChange(value,evt){
        this.setState({[evt.target.name]:value});
    }
    onLogin(){
        const {email,password} = this.state;
        this.props.login(email,password);
    }
    render(){
        return (
                <LoginView
                    loading={this.props.loading}
                    email={this.state.email}
                    password={this.state.password}
                    onChange={this.onChange}
                    onSubmit={this.onLogin}/>
        )
    }
}

function mapStateToProps(state){
    return {
        loading:state.auth.authenticating,
        authenticated:state.auth.authenticated,
        authError:state.auth.authError,
        error:state.auth.error,
        redirect:state.auth.redirect,
        authoriseFlow:state.auth.authoriseFlow,
        authoriseRedirect:state.auth.redirect,
    }
}

export default WithNotifications(connect(mapStateToProps,{login,logout,authQueryLogin})(Login));


// WEBPACK FOOTER //
// ./src/components/Login/index.js